<via-header></via-header>
<article>
  <ng-content></ng-content>
</article>
<via-footer></via-footer>
